/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
      $( '.mec-filter' ).click( function() {
        // Get parent `<li/>`
        $( '.mec-filter' ).removeClass( 'underline' );
        $( this ).addClass( 'underline' );

        // Set filters
        const transition = 'fade';
        const speed = 250;
        const data = this.dataset;

        console.log( data );

        // Call core Ajax Load More `filter` function
        ajaxloadmore.filter( transition, speed, data );
      } );
    },
  };
  app.registerComponent( 'events', COMPONENT );
} )( app );
